import {
  formatPropertyAddressInlineWithUnit,
  formatPropertyUnitDisplayForProperty,
} from "../../../../../../../../_shared/_logic/unit-labels"
import {
  DATE_ONLY_REGEX,
  formatDateOnlyDisplay,
} from "../../../../../../../_shared/_logic/timezones"

export const formatDate = (value: string | null | undefined) => {
  if (!value) return "–"

  if (DATE_ONLY_REGEX.test(value)) return formatDateOnlyDisplay(value)

  const parsed = new Date(value)

  if (Number.isNaN(parsed.getTime())) return "–"

  return parsed.toLocaleDateString("de-DE")
}

export const formatDateTime = (value: string | null | undefined) => {
  if (!value) return "–"

  const parsed = new Date(value)

  if (Number.isNaN(parsed.getTime())) return "–"

  return `${parsed.toLocaleDateString("de-DE")} ${parsed.toLocaleTimeString("de-DE", {
    hour: "2-digit",
    minute: "2-digit",
  })}`
}

export const formatAddress = (property?: Property | null, propertyUnitId?: string | null) => {
  if (!property) return "Unbekannte Liegenschaft"

  return formatPropertyAddressInlineWithUnit(property, propertyUnitId) || "Unbekannte Liegenschaft"
}

export const formatCompactAddress = (
  property?: Property | null,
  propertyUnitId?: string | null,
) => {
  if (!property) return "Unbekannte Liegenschaft"

  const base = [property.street, property.house_number].filter(Boolean).join(" ").trim()
  const unitLabel = formatPropertyUnitDisplayForProperty(property, propertyUnitId)
  const compactParts = [base, unitLabel].filter(Boolean)

  return compactParts.join(", ") || "Unbekannte Liegenschaft"
}
